import { hysdk } from './hy-sdk';

export function openOrRedirect(url: string, options?: { target?: string }): void {
  const { isViduApp, os, isLenovoMini } = hysdk.sniff;
  if ((isViduApp && os === 'ios') || isLenovoMini) {
    window.location.href = url;
    return;
  }
  const handle = window.open(url, options?.target || '_blank');
  // If the browser blocks the pop-up, redirect the current page to the URL
  if (!handle) {
    window.location.href = url;
  }
}
